module.exports = __webpack_public_path__ + "static/media/Twitter.af121f6f.png";